export const siteModels = [
  {
    name: 'site',
    fields: [
      'active',
      'allergenCard',
      'allergenFilter',
      'avoidingGluten',
      'brandColor',
      'categoryTextCatering',
      'categoryTextParents',
      'city',
      'customAllergens',
      'customShopHowItWorks',
      'customerLogin',
      'deliveryReady',
      'displayEmail',
      'dst',
      'email',
      'foodInsecurity',
      'gmtOffset',
      'hasCateringItems',
      'hasMingleNoshItems',
      'hasParentItems',
      'id',
      'integratedGateway',
      'legacyMenus',
      'linkToSchool',
      'mealPlanSubscriptions',
      'mingleNoshActive',
      'mppSso',
      'name',
      'notifications',
      'pickupReady',
      'porkIcon',
      'prelaunch',
      'published',
      'shopApplyDeliveryFee',
      'shopApplyDeliveryMin',
      'shopApplyTax',
      'shopCateringDescription',
      'showCateringItems',
      'shopCateringSection',
      'shopClosed',
      'shopClosedMsg',
      'shopDelivery',
      'shopDeliveryFee',
      'shopDeliveryMin',
      'shopLaunchReady',
      'shopMsg1Active',
      'shopMsg2Active',
      'shopMsg3Active',
      'shopMsgDesc1',
      'shopMsgDesc2',
      'shopMsgDesc3',
      'shopMsgIcon1',
      'shopMsgIcon2',
      'shopMsgIcon3',
      'shopMsgTitle1',
      'shopMsgTitle2',
      'shopMsgTitle3',
      'shopOnCampus',
      'shopParentDescription',
      'showParentItems',
      'shopParentSection',
      'shopPayWithCc',
      'shopPayWithSid',
      'shopRequireStudentId',
      'shopShipping',
      'shopSubscriptions',
      'shopTaglineIcon',
      'shopTaxRate',
      'showCateringItems',
      'showParentItems',
      'slug',
      'socialMedia',
      'state',
      'textColor',
      'transparentHeader',
      'shopCustomTagline',
      'unitId',
      'url',
      'useShopCustomTagline',
      'webtritionVersion',
    ],
    lists: ['publishedSectionList'],
    relationships: {
      address: {
        jsonApi: 'hasOne',
      },
      shoppingCart: {
        jsonApi: 'hasMany',
        type: 'shoppingCart',
      },
    },
  },
  {
    name: 'address',
    fields: [
      'city',
      'confirmed',
      'coordinates',
      'dst',
      'gmtOffset',
      'manualCoords',
      'mapTuned',
      'metadata',
      'phone',
      'state',
      'street',
      'zipCode',
      'address',
      'phoneFormatted',
    ],
  },
]
